module.exports = __webpack_public_path__ + "static/img/sactionmenban1.4145b36b.png";